import $ from "../$.js";
import * as Html from "./Html.ts";

export type ProgressBar = {
  progress : (percent :number)=>void;
  close : ()=>void;
}

export const none :ProgressBar = {
  progress:(percent :number)=>{},
  close:()=>{}
}

export const standard :ProgressBar & {frontDiv:JQuery,showTimeout:number} = {
  frontDiv : $(".fw-loading"),
  showTimeout : undefined,
  progress(percent :number){
    clearTimeout(this.showTimeout);
    //we show it
    this.frontDiv.css('display','flex');
    this.showTimeout = setTimeout(()=>{
      this.frontDiv.css('opacity',1);
    },200);
    
  },
  close(){
    clearTimeout(this.showTimeout);
    this.frontDiv.hide().css('opacity',0).find('p').html('');
  }
};


export function auto(){
  return Html.isRunningClick()?standard:none;
}